"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vicopisano": {
    "8fc579ed": [{
      "hkey": "6a2a23b4",
      "slug": "cucigliana-lugnano",
      "name": "Cucigliana-Lugnano",
      "primary": true,
      "skipSearch": false
    }],
    "cucigliana": [{
      "hkey": "6a2a23b4",
      "slug": "cucigliana-lugnano",
      "name": "Cucigliana-Lugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bb8d81e2": [{
      "hkey": "6a2a23b4",
      "slug": "cucigliana-lugnano",
      "name": "Cucigliana-Lugnano",
      "primary": true,
      "skipSearch": false
    }],
    "lugnano": [{
      "hkey": "6a2a23b4",
      "slug": "cucigliana-lugnano",
      "name": "Cucigliana-Lugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vicopisano"
    }]
  }
};
exports["default"] = _default;